/* global */

import './style.less';

export default function($log, $state, $stateParams) {
  'ngInject';

  const vm = this;
  vm.$onInit = activate;

  vm.stateParams = $stateParams;
  vm.state = $state;

  function activate() {
    $log.debug('Admin Courses Manager Nav View Activated');
  }
}



// WEBPACK FOOTER //
// ./src/app/controllers/admin/courses/nav/index.js